export default {
  packRefinement: { completePattern: '完成版型尺寸', patternDone: '版型尺寸已完成' },
  app: {
    name: 'Design Sheet',
    shortName: 'Design Sheet',
    wordmarkDesign: 'design',
    wordmarkSheet: 'sheet',
    company: 'E·LAND China',
  },

  common: {
    confirm: '确定',
    cancel: '取消',
    save: '保存',
    saved: '已保存',
    deleted: '已删除',
    saveDraft: '保存草稿',
    submit: '提交',
    delete: '删除',
    edit: '编辑',
    detail: '详情',
    expandDetails: '展开详情',
    collapseDetails: '收起详情',
    search: '查询',
    select: '请选择',
    reset: '重置',
    export: '导出',
    back: '返回',
    loading: '加载中…',
    refresh: '刷新',
    noData: '暂无数据',
    total: '共 {n} 条',
    operation: '操作',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    createdBy: '创建人',
    yes: '是',
    no: '否',
    language: '语言',
  },

  auth: {
    homeHeadlineFirst: '从设计稿，',
    homeHeadlineLast: '到技术包。',
    homeDescription: '整理款式资料，协同面辅料与版型尺寸，完成生产交接。',
    homeHeroAlt: '服装设计工作室，摆放着人台、面料与设计手稿',
    homeFeaturesLabel: '工作内容',
    homeDesignTitle: '设计资料',
    homeDesignDescription: '导入设计稿，整理款式信息。',
    homeCollaborateTitle: '协作录入',
    homeCollaborateDescription: '共同完善面辅料与版型尺寸。',
    homeTechPackTitle: '技术包',
    homeTechPackDescription: '集中核对、预览与导出。',
    loginHelp: '登录帮助',
    homeNavigation: '首页导航',
    homeCopyright: '© 2026 E·LAND GROUP. All Rights Reserved.',
    loginHelpScanTitle: '企业微信登录',
    loginHelpScanDescription: '请使用企业微信扫描页面二维码登录。',
    loginHelpAccessTitle: '登录支持',
    loginHelpAccessDescription: '如无法登录或需申请开通，请通过企业微信联系孟宪秋。',
    homeAboutTitle: '关于 Design Sheet',
    homeAboutGoalTitle: '项目目标',
    homeAboutDescription: 'Design Sheet 汇集款式资料、面辅料、版型尺寸与技术包，支持各岗位协作完成从设计到生产的交接，减少重复录入，并保留修改与确认记录。',
    homeAboutRoles: '支持商品企划、设计师、面辅料采购、版师、生产管理及设计室长协作。',
    homeAboutProgressTitle: '当前进度',
    homeAboutProgressDescription: '目前处于 ND、EE 品牌测试阶段，已支持资料导入、协作录入、设计审批及 Tech Pack 预览与导出。订货系统与 SAP 数据对接仍在验证，后续将继续完善数据衔接和操作体验。',
    homeAboutFeedbackTitle: '意见反馈',
    homeAboutFeedbackDescription: '如有使用问题或改进建议，请通过企业微信联系孟宪秋，并提供相关款号、操作说明或截图。',
    esiLogin: '企业微信扫码登录',
    continueWecomLogin: '继续登录',
    openWecomLogin: '打开企业微信登录页',
    qrLoading: '二维码加载中…',
    qrUnavailable: '二维码暂时无法加载',
    esiNoAccess: '此账号尚未开通 Design Sheet，请联系管理员',
    testAccountLogin: '测试账号登录',
    loginTitle: '登录',
    loginSubtitle: '请输入账号和密码',
    username: '账号 / 工号',
    password: '密码',
    usernamePlaceholder: '请输入账号或工号',
    passwordPlaceholder: '请输入密码',
    login: '登 录',
    logout: '退出登录',
    logoutConfirm: '确定要退出登录吗？',
    loginSuccess: '登录成功',
    sessionKept: '服务暂时不可用，登录状态已保留。服务恢复后点击「重试」即可，无需重新输入密码。',
    retryRestore: '重试',
    changePassword: '修改密码',
    currentPassword: '当前密码',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    profile: '个人信息',
    department: '部门',
    roles: '角色',
  },

  about: {
    title: '关于 Design Sheet',
    desc: '软件版本信息与发布编号规则。',
    version: '软件版本',
    stage: '发布阶段',
    devStage: '开发中',
    testStage: '测试版',
    buildTime: '构建时间',
    noteSeparate: '软件版本标识应用发布。委托书阶段记录评价会、订货会或大货；记录版本是数字序号，QC 轮次另行编号。',
    versionLine: '反馈问题时请附以下版本信息:',
    rulesTitle: '版本编号规则',
    colNo: '编号',
    colWhen: '适用场景',
    rulePatch: '问题修复,递增修订号',
    ruleMinor: '新增兼容功能,递增次版本号',
    ruleMajor: '正式发布版本',
    ruleRc: '正式发布前的候选版本',
    rulesNote: '版本号唯一来源为项目根 package.json,由构建流程注入界面;本页为只读展示。',
  },
  nav: {
    integrations: "接口状态",
    dashboard: '任务与管理',
    workbench: '我的待办',
    sheet: '委托书',
    sheetList: '委托书列表',
    legacySheets: '历史委托书',
    sheetDetail: '委托书详情',
    sheetCreate: '创建委托书',
    sheetApproval: '委托书审批',
    spec: '规格录入',
    fabricWidth: '面料幅宽',
    trimAttr: '辅料信息',
    baseSize: '基准尺寸',
    materialUsage: '面料用量',
    trimUsage: '辅料用量',
    sizeTolerance: '尺寸偏差',
    sap: 'SAP 传送',
    sapTransfer: '数据传送',
    sapLog: '传送记录',
    permissions: '角色权限',
    admin: '系统管理',
    userManage: '用户管理',
    costConfig: '汇率与成本参数',
    subMaterials: '辅料库',
    business: '业务',
    system: '系统',
    masterData: '基础数据',
    masterDicts: '基础字典',
    roleManage: '角色权限',
    about: '关于',
    auditLog: '审计日志',
    sapTransfers: 'SAP 传送状态',
  },

  role: {
    ADMIN: '系统管理员',
    APPROVER: '设计室长',
    DESIGNER: '设计师',
    PRODUCTION: '生产管理',
    FABRIC: '面辅料采购',
    PATTERN: '版师',
    PLANNER: '商品企划',
    VIEWER: '只读用户',
  },

  perm: {
    mgrTitle: '用户权限管理',
    mgrHint: '默认跟随角色；给个别人单独勾权限后标记「自定义」。修改保存后，该用户需要重新登录生效。',
    searchUser: '搜索用户',
    pickUser: '← 选择一位用户开始配置',
    custom: '自定义',
    roleDefault: '当前为角色默认权限',
    resetToRole: '恢复角色默认',
    revokeHint: '保存会吊销该用户的登录状态（权限在令牌里）；正在使用的窗口最长 2 小时后自然失效。',
    saved: '权限已保存',
    desc: '本页由系统里的权限定义实时生成，不是手写文档 —— 规则改了这里立刻跟着变，可以直接对着讨论。',
    mine: '我的权限',
    myScopes: '当前可编辑的模块',
    noneEditable: '无（本角色不参与委托书录入）',
    adminNote: '系统管理员对所有模块放行，不受下表限制。',

    matrixTitle: '谁能编辑什么',
    matrixHint:
      '委托书被切成下面这些「编辑域」，每个域有固定的负责角色。各角色并行工作、互不阻塞。切换右侧的单据状态，可以看出不同状态下谁被锁住。',
    previewStatus: '按此状态查看',
    scope: '编辑域',
    approvalBound: '受设计审批约束',
    legendYes: '可以编辑',
    legendLocked: '本角色负责，但当前状态下锁定',
    legendNo: '不可编辑（只能查看）',

    stagesTitle: '分节完成标记归谁打',
    stagesHint: '同一节的多个标记可能分属不同角色 —— 面辅料节的三个标记就是三个人各打各的。',
    section: '分节',
    stage: '完成标记',
    owner: '负责角色',
    adminOnly: '仅系统管理员',

    approvalTitle: '设计审批流转',
    flowSubmit: '设计师提交',
    flowApprove: '设计室长通过',
    flowReject: '设计室长驳回',
    flowResubmit: '设计师修改后再提交',
    ruleParallel: '只审设计师负责的内容。其它角色任何时候都能录入，不看审批状态。',
    rulePendingLock: '审批中（已提交、未裁决）设计内容锁定 —— 正在审的东西不能变。',
    ruleEditAfterApprove:
      '通过之后仍可修改，但一改批准即失效、自动退回草稿，需要重新提交审批（状态历史里会留一条记录）。',
    ruleRejectMemo: '驳回必须填写意见，设计师据此修改；可以反复驳回、反复重提，每一轮都有留痕。',
    ruleCancelled: '单据作废后，所有模块一律不可编辑。',

    rolesTitle: '各角色持有的权限点',
    rolesHint: '权限点决定能不能进某个接口；上面的编辑域决定进去之后能改哪一块。两者都要满足。',
    permissionCount: '个权限点',
    myRoleNote: '当前角色为「{role}」，共 {n} 个权限点。',

    source: '数据来源：编辑域取自共享包 constants/edit-scopes.ts，权限点取自数据库的角色配置。',
  },

  editScope: {
    SOURCE_INFO: '款式来源信息',
    ORDER_QUANTITY: '订货数量修改',
    PATTERN_INFO: '版型引用信息',
    PRODUCTION_INFO: '成衣供应商',
    MANUAL_STYLE: '手工款颜色与尺码',
    MANUAL_COMMERCE: '手工款售价与数量',
    ORDER_INFO: '入库要求日期',
    DESIGN: '设计',
    COLORWAY: 'ColorWay 配色',
    USP: 'USP·设计意图',
    FABRIC_BASE: '面料信息',
    FABRIC_PROD: '面料生产列',
    TRIM: '辅料 BOM',
    CONSUMPTION: '面料用量',
    TRIM_CONSUMPTION: '辅料用量',
    PRICE: '单价',
    COST: '成本录入',
    TRIM_TECHNICAL: '辅料技术资料',
    SIZE_DEVIATION: '尺寸偏差',
    SIZE_SPEC: '基准尺寸',
    QUANTITY: '订货数量（只读）',
    ONLINE: '在线商品信息',
    QC: 'QC 委托书',
    TECHPACK_EXPORT: 'Tech Pack 最终确认',
  },

  editScopeWhere: {
    MANUAL_STYLE: '商品企划维护手工款颜色与尺码；设计师从中选择基准尺码。',
    MANUAL_COMMERCE: '商品企划维护手工款售价、数量、订货资料和人员。',
    ORDER_INFO: '04 节：商品企划或生产管理维护入库要求日期。',
    ORDER_QUANTITY: '商品企划在委托书中修改颜色、尺码对应的订货数量，保留来源与修改记录。',
    PATTERN_INFO: '本款版师维护版型模块号和参考委托书、款号。',
    DESIGN: '01 节：设计图稿 / 主信息 / 设计 Memo / 详细图片',
    COLORWAY: '02 节：ColorWay 配色表',
    USP: '08 节：核心卖点与设计意图',
    FABRIC_BASE: '02 节面料：使用部位 / 分类 / 代码 / 名称 / 成分 / 后整理 / 供应商 / 适用颜色',
    FABRIC_PROD: '02 节面料：幅宽、单位、重量（主流程第 7 步）',
    TRIM: '02 节：辅料 BOM 的结构与属性',
    CONSUMPTION: '面料用量由版师填写',
    TRIM_CONSUMPTION: '辅料用量由设计师初填、版师核对',
    PRICE: '02 节：面料与辅料的单价、币种（成本计算用）',
    COST: '02 节成本：采购模式、FOB 报价、加工费、外包工程费、通关费；冻结成本快照',
    TRIM_TECHNICAL: '02 节：辅料颜色、规格与技术备注（版师）',
    SIZE_DEVIATION: '03 节：左右偏差与允许值（版师）',
    SIZE_SPEC: '03 节：基准尺寸、分尺码值与测量方法（版师）',
    QUANTITY: '04 节：订货数量，由前序环节确定，只读查看。',
    ONLINE: '07 节：在线商品信息',
    QC: '06 节：QC 委托书各轮次',
    TECHPACK_EXPORT: '05 节：生产管理最终确认；本款查看者可导出',
  },

  admin: {
    usersDesc: '一人一个角色。角色决定这个人能编辑委托书的哪些模块，其余模块只能查看。',
    createUser: '新建用户',
    editUser: '编辑用户',
    username: '账号 / 工号',
    usernameRequired: '请输入账号',
    usernamePattern: '账号只能用字母、数字与 . _ -',
    displayName: '姓名',
    displayNameRequired: '请输入姓名',
    role: '角色',
    roleRequired: '请选择角色',
    noRole: '未分配',
    department: '部门',
    email: '邮箱',
    locale: '界面语言',
    status: '状态',
    active: '启用',
    inactive: '停用',
    activate: '启用',
    deactivate: '停用',
    lastLogin: '最近登录',
    authProvider: '认证方式',
    authLocal: '账号密码',
    authSso: '企业微信',
    bound: '已绑定',
    searchPlaceholder: '搜索账号 / 姓名 / 邮箱',
    resetPassword: '重置密码',
    resetPasswordConfirm: '重置 {name} 的密码？系统会生成新的临时密码，该用户当前的登录会立即失效。',
    deactivateConfirm: '停用 {name}？停用后该用户立即无法登录。',
    activateConfirm: '重新启用 {name}？',
    cannotChangeOwnRole: '不能修改自己的角色，避免把自己锁在门外',
    brands: '可见品牌',
    allBrands: '全部品牌',
    noBrand: '未设置',
    brandsPlaceholder: '选择品牌，可多选',
    brandsHint: '选择明确授权的业务品牌。未启用品牌的原授权继续保留，但资料暂不可查看；权限变化在后续访问时生效。',
    adminAllBrands: '系统管理员业务查询可见所有已启用品牌；品牌管理可维护全部登记品牌。',
    noBrandConfirm: '没有选任何品牌，这个人登录后一张委托书都看不到。确定这样保存吗？',
    tempPasswordHint: '创建后系统会生成一个临时密码，只显示一次，请复制后告知本人。',
    tempPasswordTitle: '临时密码',
    tempPasswordWarn: '关闭后无法再次查看。忘了就重置一次。',
    copy: '复制',
    copied: '已复制',
    copyFailed: '复制失败，请手动选中',
  },

  status: {
    DRAFT: '草稿',
    PENDING: '审批中',
    APPROVED: '已批准',
    REJECTED: '已驳回',
    CANCELLED: '已作废',
  },

  server: {
    sapTransferInProgress: '本款已有传送尚未结束。请先核对处理结果，再决定是否重新传送。',
    sapProbeReadOnly: '连接检查仅用于读取款式。传送委托书请从对应款号操作。',
    qcRemoveAttachmentsFirst: '请先移除本轮附件，再删除 QC 轮次。',
    qcRoundMissing: 'QC 轮次已不存在，请重新打开委托书。',
    qcRoundCompleted: '本轮 QC 已完成，请先取消完成标记后再修改。',
    rowEditConflict: '该表已更新，你的填写已保留。请重新打开委托书核对后再保存。',
    rowUndoUnavailable: '此次删除无法撤销。',
    rowUndoExpired: '已超过撤销时间，请重新录入。',

    scopeReadonly: '当前账号只能查看此部分，请由本款对应担当修改。',
    materialRowsChanged: '面料行已变化，请刷新并核对后再保存。',
    sizeRowsChanged: '尺寸行已变化，请刷新并核对后再保存。',
    stageDesignMissing: '请先上传设计稿并填写基准尺码。',
    stageDeviationMissing: '请先填写各部位的上、下允许值；无偏差时填 0。',
    stageWidthMissing: '请先填写各面料的幅宽。',
    stageTrimMissing: '请核对辅料代码并指定适用的尺码规格。',
    stageUsageMissing: '请先填写各面料和适用辅料的用量；无用量时填 0。',
    patternSizeEmpty: '请先保存包含部位和尺寸值的版型尺寸，再确认完成。',
    subMaterialRowsChanged: '辅料行已变化，请刷新并核对后再保存。',
    techpackNotReady: 'Tech Pack 资料确认尚未齐备，请先完成以下事项。',
    demoNoTransfer: '演示资料仅用于流程测试，不允许发送到 SAP。',
    stageMismatch: '该确认项不属于当前分节，请刷新页面后重试。',
    packNotConfirmed: '请先由生产管理最终确认 Tech Pack。',
    testViewNoPassword: '测试视角中不能修改账号密码。',
    assigneeOnlyDraft: '只可为草稿或已驳回的委托书调整负责人。',
    assigneeMismatch: '负责人须为可查看本品牌且角色相符的启用账号。',
    testViewClosed: '测试视角已关闭或已到期，请返回管理员。',
    testViewBusinessOnly: '请选择已启用的业务账号。',
    roleNotFound: '该角色不存在。',
    adminRoleProtected: '管理员权限由系统维护，不能在此修改。',
    unknownPermissions: '权限清单包含无效项目，请刷新后重试。',
    notSubmittable: '当前单据状态不允许提交审批（草稿或已驳回才能提交）',
    nothingToWithdraw: '没有在等审批的提交，无法撤回',
    nothingToDecide: '没有在等裁决的设计内容',
    rejectMemoRequired: '驳回必须填写意见',
    badCredentials: '账号或密码错误',
    accountDisabled: '账号已停用，请联系管理员',
    esiSessionExpired: 'AI Lab 登录已失效，请重新登录',
    esiAccountNotConfigured: '尚未开通 Design Sheet，请联系管理员',
    esiPasswordManaged: '此账号使用 AI Lab 登录，无需设置本地密码',
    sapResultNeedsCheck: '上一次传送结果尚未确认，请先核对 SAP 记录，勿重复传送',
    userNotFound: '用户不存在',
    wrongPassword: '当前密码不正确',
  },
  submitCheck: {
    noFlatSketch: '「设计」节缺少设计图稿',
    noStdSize: '「设计」节缺少基准尺码',
    noColorway: '「面辅料」节 ColorWay 至少需要一个启用的颜色',
    stageNotDone: '「{section}」节的「{stage}」尚未标记完成',
  },
  hero: {
    createTitle: '创建委托书',
    createDesc: '从订货会结果或加单结果开始一个新款；也可以从已有款号检索。',
    fromOrderFair: '从订货会新建',
    fromReorder: '从加单新建',
    reorderHint: '加单接口对接后开放（灰度中）',
    moreWays: '更多方式',
  },
  pipe: {
    toCreateHint: '最新订货会中尚未创建委托书的款式。点击进入订货会选款并创建;首次使用需先刷新一次订货会列表。',
    title: '我的款式流水线',
    desc: '从创建到发工厂，一款衣服走过的五段。数字可点，直达对应单据。',
    pendingApproval: '待审批（已提交）',
    approved: '已批准',
    techpackSent: 'Tech Pack 已确认',
  },
  audit: {
    title: '审计日志',
    desc: '系统里每一次写操作的留痕 —— 谁、什么时候、改了什么。点击一行展开变更前后对比。',
    keywordPh: '搜动作 / 目标 id',
    targetType: '对象类型',
    action: '动作',
    actor: '操作人',
    from: '开始时间',
    to: '结束时间',
    time: '时间',
    what: '做了什么',
    target: '对象',
    detail: '明细',
    before: '变更前',
    after: '变更后',
    scopes: {
      sheet: '整单', material: '面辅料', design: '设计', pattern: '版型·尺寸',
      qc: 'QC', usp: 'USP', online: '在线商品', cost: '成本', techpack: 'TechPack',
    },
  },
  sap: {
    transfer: '传 SAP',
    transferConfirm: '把委托书 {modelCd} 传送给 SAP(CE2)创建 D-BOM?发送内容与日志都会留档。',
    transferTitle: '传送给 SAP',
    transferOk: '已传送 SAP(见「SAP 传送状态」页)',
  },
  switch: {
    account: '切换测试账号(品牌×角色)',
    roleOnly: '仅切角色',
    reset: '恢复本人',
  },
  board: {
    pendingTasks: '待我处理',
    allTasks: '全部任务',
    pageGroupCount: '本页{count}项',

    searchPh: '搜款号 / 委托编号 / 品名',
    title: '商品看板',
    group: { none: '不分组', progress: '按完成度', season: '按年度·季节', source: '按来源' },
    viewCard: '卡片',
    viewList: '列表',
    viewAll: '查看全部',
    done: '已完成',
    ongoing: '进行中',
    cancelled: '已作废',
    unclassified: '未分类',
    continue: '继续编制',
    view: '查看',
    emptyTitle: '暂无商品',
    noImage: '暂无图',
    field: { brand: '品牌', season: '季节', source: '来源' },
    progress: '完成度',
    empty: '暂无委托书。可从订货会或已有款号开始创建。',
  },
  source: {
    DEMO: '演示资料',
    ORDER_FAIR: '大货 · 订货会',
    MANUAL: '手动建单',
    REORDER: '5日 · 加单建议',
  },
  devSwitch: {
    label: '测试 · 切换角色',
    restore: '恢复本人',
  },
  error: {
    VALIDATION_FAILED: '提交的内容有误，请检查后重试',
    UNAUTHORIZED: '登录状态已失效，请重新登录',
    TOKEN_EXPIRED: '登录状态已失效，请重新登录',
    FORBIDDEN: '没有权限执行此操作',
    NOT_FOUND: '请求的数据不存在',
    CONFLICT: '数据冲突，请刷新后重试',
    INVALID_STATE: '当前单据状态不允许该操作',
    RATE_LIMITED: '操作过于频繁，请稍后再试',
    SAP_ERROR: 'SAP 接口返回异常，请联系管理员',
    SERVICE_UNAVAILABLE: '服务暂时不可用（数据库连接异常），请稍后重试',
    INTERNAL_ERROR: '服务器异常，请稍后再试',
    NETWORK: '网络连接失败，请检查网络后重试',
    UNKNOWN: '发生未知错误',
    requestId: '错误追踪号',
  },

  page: {
    todo: {
      title: '我的待办',
      desc: '当前需要您处理的事项汇总。点击卡片可查看对应单据；显示 0 表示暂无待办。',
      toCreate: '待创建（全新商品）',
      todoDrafting: '编制中（草稿）',
      pendingApproval:'等我去审批',
      rejected: '被驳回，等我修改',
      missingPrice: '还有行没填单价',
      missingUsage: '还有行没填用量',
      technicalPending: '技术资料待完成',
      approvedNotTransferred: '已批准，还没传 SAP',
      go: '去看',
    },
    dashboard: {
      title: '工作台',
      eyebrow: 'WORKBENCH',
      welcome: '欢迎回来，{name}',
      scopeTitle: '本版本重构范围',
      scopeDesc: '当前版本覆盖主流程第 5 至第 13 步，其余步骤仍在 SAP 系统中运行。',
      inScope: '本版范围',
      outOfScope: '暂不涉及',
    },
    notFound: {
      title: '页面不存在',
      desc: '访问的页面不存在或已被移除。',
      back: '返回工作台',
    },
    forbidden: {
      title: '没有访问权限',
      desc: '当前账号没有该页面的访问权限。如需开通，请联系系统管理员。',
      back: '返回工作台',
    },
  },

  integration: {
    pageHint: "EADS ↔ SAP PI 接口的连通性。探测是手动的：每次都会真的调一次 SAP，认证失败计入熔断保护。",

    tunnelTitle: 'SSH 跳板',
    tunnelHint: '本机被防火墙挡着直连不到内网端点，请求经跳板机转发（等价于 ssh -L）。业务逻辑不受影响，只是换了条路',
    tunnelConnected: '已连接，本地转发口 {port}',
    tunnelIdle: '未连接 —— 下次调用接口时自动建立',
    tunnelNotConfigured: '配置不全：需要主机、用户，以及密码或私钥',
    tunnelNoFingerprint: '未配置主机指纹，跳过了 SSH 主机校验 —— 无法察觉中间人。建议用 ssh-keyscan 取指纹后填进 .env',
    tunnelReconnect: '重连跳板',
    tunnelReconnected: '已断开，下次调用时会重新建立',
    step: {
      'jump-tcp': '① 本机 → 跳板机',
      'ssh-auth': '② SSH 登录',
      forward: '③ 跳板机 → 内网端点',
      http: '④ 端点是否应答 HTTP',
      config: '配置检查',
    },
    reachTitle: "网络连通性",
    reachHint: "只做一次 TCP 握手，不带账号密码 —— 排查时先点这个：网络不通的话，账号密码再对也不可能生效，而且认证根本不会发生，不会计入锁定次数。",
    reachRun: "检查连通性",
    enabled: "总开关",
    on: "已开启",
    off: "已关闭",
    credentials: "接口账号",
    configured: "已配置",
    missing: "未配置",
    sysGbn: "系统区分",
    endpoint: "端点地址",
    circuitClosed: "账号保护正常",
    circuitOpen: "账号保护已跳闸",
    circuitDesc: "连续认证失败 {failures} / {limit} 次，本地还允许 {remaining} 次。SAP 侧连续 3 次会锁定接口账号。",
    reset: "复位",
    resetConfirmTitle: "复位账号保护",
    resetConfirm: "复位前请先确认接口账号密码无误。密码若仍是错的，继续调用会把 SAP 侧的失败次数推向 3 次锁定。确认继续？",
    resetConfirmOk: "我已确认密码，复位",
    resetDone: "已复位",
    id: "接口号",
    interfaceName: "Interface 名",
    description: "说明",
    usedBy: "本系统用在哪",
    lastProbe: "最近一次探测",
    notProbed: "未探测",
    probe: "测试连接",
    probeStyleCd: "探测用款号",
    probeStyleCdPlaceholder: "留空用默认款号",
    probeStyleCdHint: '目录里点「测试连接」时用这个款号；留空则用服务端配置的默认值',

    catalogTitle: '接口目录',
    catalogHint: '后端团队接口清单的完整版本，可当文档查。搜索会连字段名一起搜',
    catalogCounts: '共 {total} 个 · 我方可调 {callable} 个 · 已实现 {implemented} 个 · 当前显示 {shown} 个',
    catalogSearchPh: '搜接口号 / 名称 / 描述 / 字段名',
    catalogNoMatch: '没有匹配的接口',
    dirAll: '全部',
    dirOut: 'EADS → SAP',
    dirIn: 'SAP → EADS',
    dirOutShort: '我方调用',
    dirInShort: 'SAP 推送',
    onlyInUse: '只看在用',
    onlyImplemented: '只看已实现',
    noSummary: '（接口清单里没写描述）',
    noFields: '接口定义书里没有这个接口的字段表',
    tagAsync: '异步',
    tagUnused: '未启用',
    stage: {
      done: '已实现',
      registered: '已登记',
      none: '未接入',
    },
    metaProgram: 'SAP 程序',
    metaTransport: '传输方式',
    metaCycle: '调用周期',
    metaNs: '命名空间',
    metaAdapter: '适配器',
    metaOwner: '后端担当',
    metaNote: '备注',
    fField: '字段',
    fDesc: '说明',
    fType: '类型',
    fLen: '长度',
    fSample: '示例',
    fTable: '内表',
    probeConfirmTitle: "测试接口连接",
    probeConfirm: "将真实调用一次 {id}。若认证失败会计入账号保护，本地还允许 {n} 次；SAP 侧连续 3 次会锁定接口账号。确认发起？",
    probeConfirmOk: "确认发起"
  },
  sapSpot: {
    wired: '已接入',
    notWired: '未接入',
  },

  integrationResult: {
    "OK": "连通",
    "BUSINESS_ERROR": "业务错误",
    "AUTH_FAILED": "认证失败",
    "UNREACHABLE": "网络不可达",
    "BAD_RESPONSE": "响应异常",
    "NOT_CONFIGURED": "未配置",
    "CIRCUIT_OPEN": "保护跳闸",
    "UNKNOWN": "未知"
  },
  legacy: {
    eyebrow: '旧系统 EADS',
    listTitle: '历史委托书',
    listDesc: '旧系统迁移过来的历史数据（2019 年起），只读查阅',
    detailDesc: '旧系统历史数据，只读',
    keywordPlaceholder: '款号 / 款式号 / 款式名',
    brand: '品牌',
    year: '年度',
    state: '状态',
    stateCol: '状态',
    modelCd: '委托书款号',
    styleCd: '款式号',
    styleNm: '款式名',
    yearSeason: '年度 / 季节',
    designer: '设计师',
    colors: '配色',
    trims: '辅料',
    createdAt: '建单日期',
    empty: '没有数据',
    colorways: '配色',
    tagColor: 'Tag 色',
    washing: '洗涤说明',
    materials: '面料',
    usedPart: '使用部位',
    materialId: '面料编号',
    materialNm: '面料名',
    yardage: '用量',
    width: '幅宽',
    unit: '单位',
    unitPrice: '单价',
    ingredient: '成分',
    trimsSection: '辅料 BOM',
    trimCode: '辅料代码',
    trimName: '辅料名',
    trimType: '种类',
    colorMatchPart: '配色部位',
    consumption: '用量明细',
    memo: '备注',
    stdSizes: '基准尺寸',
    patternPart: '部位',
    size: '尺寸',
    tolerance: '公差',
    measurement: '测量方法',
    progress: '进度履历',
    statusDate: '日期',
    comment: '说明',
    modiHistory: '修改履历',
    modiTime: '时间',
    amendTable: '表',
    amendField: '字段',
    beforeAfter: '前 → 后',
    designMemos: '设计备注',
    salePrice: '售价',
    chargePattern: '纸样担当',
    chargePurchase: '采购担当',
    chargeProduction: '生产担当',
  },

  dict: {
    eyebrow: '基础数据',
    title: '基础字典',
    desc: '商品颜色（按品牌）、尺码-类别映射、面料颜色。首次导入自参考文件，此后在页面维护',
    brandColor: '商品颜色',
    sizeCategory: '尺码类别',
    materialColor: '材料颜色',
    keywordPlaceholder: '搜代码 / 名称',
    brand: '品牌',
    colorCd: '颜色代码',
    colorNm: '英文名',
    nameZh: '中文名',
    nameKo: '韩文名',
    used: '启用',
    cate1: '大分类码',
    cate1Name: '大分类名称',
    cate1NameZh: '大分类中文名',
    cate1NameKo: '大分类韩文名',
    cate1Placeholder: '无大类可留空',
    sizeCd: '尺码代码',
    segment: '尺码段',
    segmentZh: '尺码段（中文）',
    segmentKo: '尺码段（韩文）',
    brands: '适用品牌',
    family: '色系',
    colorName: '色名',
    add: '新增',
    addTitle: '新增字典项',
    editTitle: '编辑字典项',
    deleteConfirm: '确定删除这条字典项吗？已录入单据里的旧值不受影响，但下拉/检索将不再出现。',
  },
  sapTransfer: {
    states: { SUCCESS: '已传送', FAILED: '未成功', SENDING: '传送中', PENDING: '待传送', RECONCILE: '结果待核对' },
    empty: '还没有传送记录 —— 审批通过的委托书传 SAP 后会出现在这里。',
    title: 'SAP 传送状态',
    desc: '委托书传给 SAP（SP0070）的每一次记录，失败的可以人工重发',
    refresh: '刷新',
    allStatus: '全部状态',
    time: '开始时间',
    sheet: '委托书',
    channel: '通道',
    status: '状态',
    error: '失败原因',
    by: '操作人',
    actions: '操作',
    resend: '重发',
    resendTitle: '重发 SAP 传送',
    resendConfirm: '重新传送委托书 {model} ？会按最新内容完整重走一遍（含预检）。',
    resendOk: '重发成功',
  },

};
